import * as React from 'react';
import styled from 'styled-components';
import { style, ResponsiveValue } from 'styled-system';
import { media } from '../../theme/media';
import is from '../../theme/utils/condition';

const ratio = style({
  prop: 'ratio',
  cssProperty: 'padding-top',
  transformValue: (ratio) => `${Number(ratio) * 100}%`,
});

const Container = styled.div<{ ratio?: ResponsiveValue<number>; isHeightLimited: boolean }>`
  position: relative;
  display: block;
  ${is('isHeightLimited')`
      ${media.from.xxl`
       max-height: 388px;
      `}
  `}

  &::before {
    content: '';
    display: block;
    ${ratio};
  }
  > div {
    position: absolute;
    display: flex;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
`;

export interface FixedRatioProps {
  /**
   * the children to render inside
   */
  children?: React.ReactNode;
  /**
   * change styling of the inner wrapper
   */

  className?: string;

  /**
   * ratio to keep (styled-system Responsive Style Props)
   *
   * @example
   *
   * // square
   * <FixedRatio ratio={1}>
   * // wide
   * <FixedRatio ratio={9/16}>
   *
   * // square on first, wide from second break-point
   * <FixedRatio ratio={[1, 9/16]}>
   */
  ratio?: ResponsiveValue<number>;
  isTilesWithFlags?: boolean;
  isHeightLimited?: boolean;
}

export const FixedRatio: React.FC<FixedRatioProps> = ({
  children,
  ratio,
  className,
  isHeightLimited = true,
  ...rest
}) => (
  <Container ratio={ratio} isHeightLimited={isHeightLimited} {...rest} data-testid="fixed-ratio">
    <div className={className}>{children}</div>
  </Container>
);
